// UI strings. Arabic is primary; add an `en` dictionary with the same keys to enable English.
const ar = {
  appName: "فريق",
  home: "الرئيسية", myTasks: "مهامي", tasks: "المهام", projects: "المشاريع", myEval: "تقييمي", more: "المزيد",
  teams: "الفرق", approvals: "الاعتمادات", reports: "التقارير", people: "الموظفون والصلاحيات", settings: "الإعدادات",
  notifications: "الإشعارات", logout: "تسجيل الخروج", profile: "حسابي",
  loading: "جارٍ التحميل…", retry: "إعادة المحاولة", save: "حفظ", cancel: "إلغاء", close: "إغلاق",
  saved: "تم الحفظ", empty: "لا توجد بيانات",
  status: {
    new: "جديدة", in_progress: "قيد التنفيذ", pending_review: "بانتظار المراجعة", returned: "معادة للتعديل",
    blocked: "متوقفة بعائق", approved: "مكتملة ومعتمدة", cancelled: "ملغاة",
  },
  priority: { low: "منخفضة", normal: "عادية", high: "عالية", urgent: "عاجلة" },
  projectStatus: { planned: "مخطط", active: "جارٍ", on_hold: "متوقف", completed: "مكتمل", archived: "مؤرشف" },
  role: { admin: "مدير النظام", project_manager: "مدير مشروع", team_lead: "قائد فريق", employee: "موظف / فني" },
  userStatus: { invited: "مدعو", active: "نشط", disabled: "معطّل" },
  category: {
    before: "صور قبل", after: "صور بعد", report: "مرفق تقرير", delivery: "ملفات التسليم", instruction: "تعليمات",
    project_file: "ملف مشروع", obstacle_evidence: "دليل عائق", other: "أخرى",
  },
  reason: {
    materials_shortage: "نقص مواد", site_not_ready: "عدم جاهزية الموقع", waiting_client: "انتظار العميل",
    waiting_other_team: "انتظار فريق آخر", other: "سبب آخر",
  },
  rework: { execution_error: "خطأ تنفيذي", scope_change: "تغيير نطاق الطلب", documentation: "نقص التوثيق" },
  obstacleStatus: { pending: "بانتظار القرار", approved: "معتمد", rejected: "مرفوض", resolved: "تم الاستئناف" },
};

const dictionaries = { ar };
let lang = "ar";

export function t(path) {
  const v = path.split(".").reduce((o, k) => (o == null ? o : o[k]), dictionaries[lang]);
  return v ?? path;
}
export const dir = () => (lang === "ar" ? "rtl" : "ltr");

const TZ = "Africa/Tripoli";
const dtf = new Intl.DateTimeFormat("ar-LY", {
  timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
  hour12: false, numberingSystem: "latn",
});
const df = new Intl.DateTimeFormat("ar-LY", { timeZone: TZ, year: "numeric", month: "long", day: "numeric",
  numberingSystem: "latn" });

export const fmt = {
  dt: (v) => (v ? dtf.format(new Date(v)) : "—"),
  date: (v) => (v ? df.format(new Date(v)) : "—"),
  num: (v, d = 0) => (v == null ? "—" : Number(v).toLocaleString("en-US", { maximumFractionDigits: d })),
  size(b) {
    if (b == null) return "—";
    if (b < 1024) return b + " بايت";
    if (b < 1024 ** 2) return (b / 1024).toFixed(0) + " ك.ب";
    return (b / 1024 ** 2).toFixed(1) + " م.ب";
  },
  relative(v) {
    if (!v) return "";
    const diff = (new Date(v) - Date.now()) / 36e5;
    const abs = Math.abs(diff);
    const s = abs < 1 ? `${Math.round(abs * 60)} دقيقة` : abs < 48 ? `${Math.round(abs)} ساعة` : `${Math.round(abs / 24)} يوم`;
    return diff >= 0 ? `بعد ${s}` : `منذ ${s}`;
  },
};

// <input type="datetime-local"> works in the browser's zone; the company works in Libya time (UTC+2).
export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(new Date(iso).getTime() + 2 * 36e5);
  return d.toISOString().slice(0, 16);
}
export function fromLocalInput(v) {
  return v ? new Date(v + ":00+02:00").toISOString() : null;
}
